import React, { useRef } from "react";

export interface TextareaProps {
  id?: string;
  value?: string;

  maxCharacters?: number;
  placeholder?: string;
  readOnly?: boolean;
  resize?: boolean;
  onChange?(value: string): void;
  handleBlur?(): void;
}

/**
 * Textarea component
 */
const Textarea = (props: TextareaProps) => {
    const ref = useRef<HTMLTextAreaElement>(null);

    const {
        id = "",
        value = "",
        onChange = () => {},
        maxCharacters = false,
        readOnly = false,
        resize = false,
        placeholder = "",
        handleBlur = () => {/**/}
    } = props;

    return (
        <textarea
        {...(maxCharacters && { maxLength: maxCharacters })}
        style={resize ? {} : { resize: "none" }} // Updated line
            id={id}
            ref={ref}
            value={String(value)}
            onChange={(e) => {
                const selectionStart = e.target.selectionStart === null
                    ? e.target.value.length
                    : e.target.selectionStart;

                onChange(e.target.value);

                // Prevent cursor from jumping to end of input when typing - IMPORTANT!
                setTimeout(() => {
                    if (ref.current) ref.current.setSelectionRange(selectionStart, selectionStart);
                }, 0);
            }}
            readOnly={readOnly}
            placeholder={placeholder}
            onBlur={handleBlur}
        />
    );
};

export default Textarea;
